import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'

const DescriptionRefund: React.FC<descriptionProps> = ({
  onCancel,
  onSubmitDesctiption,
}) => {
  const form = useForm()

  return (
    <div>
      <Form
        classes="gap-x-6"
        form={form}
        onSubmit={(v) => onSubmitDesctiption && onSubmitDesctiption(v)}
      >
        <h1 className="col-span-12 mb-3 text-center">
          Ingrese una descripción
        </h1>
        <FormItem
          name="description"
          classes="col-span-12 mb-3"
          rules={{ required: 'Es necesario una descripcion' }}
        >
          <InputText placeholder="Descripcion" />
        </FormItem>

        <div className="col-span-12 h-full flex flex-row">
          <div className="w-1/2 mr-5 pl-1">
            <Button
              onClick={() => {
                if (onCancel) onCancel()
              }}
              type="outline"
              classes="w-full"
            >
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button type="primary" classes="w-full" htmlType="submit">
              Realizar devolución
            </Button>
          </div>
        </div>
      </Form>
    </div>
  )
}

interface descriptionProps {
  onCancel?: Function
  onSubmitDesctiption?: Function
}

export default DescriptionRefund
